import "./es-polyfills";

import mithril from "mithril";
import mithril_mu from "mithril-mu";
import text from "./text";
import sizeMonitor from "./sizemonitor";
import {domid} from "./utils";

const defaultMuTransforms = {};

mithril.µ = mithril_mu(mithril, defaultMuTransforms);


var _domLang = function (elm) {
    while (elm && !elm.lang) {
        elm = elm.parentNode;
    }
    return (elm ? elm.lang : '').toLowerCase();
};


var loadCss = function (widget) {
    var cssUrl = widget.cssUrl;
    if (cssUrl) {
        var doc = widget.env.document;
        var cssLink = cssUrl && doc.querySelector('link[href="' + cssUrl + '"]');
        if (!cssLink) {
            cssLink = doc.createElement('link');
            cssLink.rel = 'stylesheet';
            cssLink.setAttribute('href', cssUrl);
            cssLink._usageCount = 0;
            cssLink.isLoaded = false;
            // Not sure if this works in older mobile browsers...
            cssLink.onload = function () {
                setTimeout(function () {
                    cssLink.isLoaded = true;
                    // console.warn( 'Widget CSS loaded' );
                    mithril.redraw();
                }, 200);
            };
            doc.head.appendChild(cssLink);

            // // If the above "onload" doesn't work, then use this
            // mithril.request({ url:cssUrl, background:true, deserialize:function(){ return ''; } })
            //     .then(function(){
            //       doc.head.appendChild( cssLink );
            //       setTimeout(function() {
            //         cssLink.isLoaded = true;
            //         // console.warn( 'Widget CSS loaded' );
            //         mithril.redraw();
            //       }, 200);
            //     });
        }
        cssLink._usageCount++;
        widget.cssLink = cssLink;
    }
};

var unloadCSS = function (widget) {
    var cssLink = widget.cssLink;
    if (cssLink) {
        cssLink._usageCount--;
        if (cssLink._usageCount < 1) {
            cssLink.parentNode.removeChild(cssLink);
        }
    }
};


var start = function () {
    //console.log(this.widgetId + '.start()');
    var widget = this;
    var m = widget.m;
    loadCss(widget);
    widget.state.init();
    widget.txt.start();
    m.mount(
        widget.env.containerElm,
        m(widget.mainComponent, widget)
    );
    widget.sizeMonitor.on(function (/*format*/) {
        widget.m.redraw();
    });
    setTimeout(function () { // can we skip this timeout?
        widget.sizeMonitor.start();
    }, 100);
};

var destroy = function () {
    var widget = this;
    var env = widget.env;
    widget.sizeMonitor.stop();
    widget.m.mount(env.containerElm, null);
    widget.state.clear();
    if (env.wrapperElm.parentNode) {
        env.wrapperElm.parentNode.removeChild(env.wrapperElm);
    }
    unloadCSS(widget);
};


/**
 * Return URL to server, where we expect to find `widgets` folder containing each widget distribution folder.
 * We return configures URL if found. Then look for our script URL and go up 3 levels. Finally falling back to default.
 */
const _resolveServerUrl = function (cfg, staticProps) {
    if (cfg.server_url) return cfg.server_url;
    let widgetScriptTag = document.querySelectorAll('script[data-belgingur]')[0];
    if (widgetScriptTag) {
        return widgetScriptTag.src.replace(/\/$/, '').replace(/(\/[^/]*){3}$/, '');
    }
    return staticProps.default_server_url;
};

var _resolveApiUrl = function (cfg, staticProps, serverUrl) {
    return (cfg.api_url ||
    cfg.server_url ||
    serverUrl ).replace(/\/$/, '');
};

var _resolveCssUrl = function (cfg, staticProps, widgetUrl, env) {
    var cfgStyling = cfg.styling || 'default';
    var cssUrl = '';
    if (cfgStyling === 'none' && cfg.inline) {
        cssUrl = null;
    }
    else if (/^(?:\.|\/|https?:\/\/)/.test(cfgStyling)) {
        cssUrl = cfgStyling;
    }
    else {
        var cssPresets = staticProps.cssPresets;
        var styleName = cssPresets.indexOf(cfgStyling) > -1 ? cssPresets : 'default';
        cssUrl = widgetUrl + styleName + (env.iframe ? '' : '--inline') + '.css';
    }
    return cssUrl;
};


// Features of Widgets:
//   * Tolerate repeat instantiations with new config.
var initWidget = function (widgetFactory, cfg, wrapperElm, staticProps) {

    var widget = {};

    // Tolerate repeat instantiations with new config.
    var existingWidget = wrapperElm.belgingurWidget;
    if (existingWidget) {
        existingWidget.destroy();
        widget = existingWidget;
    }

    // methods
    widget.loadCss = loadCss;
    widget.unloadCSS = unloadCSS;
    widget.start = start;
    widget.destroy = destroy;

    wrapperElm.className = staticProps.wrapperClass;

    // environment
    var env;
    if (wrapperElm instanceof window.HTMLIFrameElement) {
        env = {
            iframe: wrapperElm,
            window: wrapperElm.contentWindow,
            document: wrapperElm.contentDocument,
            containerElm: wrapperElm.contentDocument.body,
            wrapperElm: wrapperElm,
        };
    }
    else {
        env = {
            window: window,
            document: document,
            containerElm: wrapperElm,
            wrapperElm: wrapperElm,
        };
    }
    widget.env = env;


    widget.normalizeApiUrl = function (url/*:string*/) {
        if (url && url.charAt(0) === '/') {
            url = widget.api_url + url;
        }
        return url;
    };


    widget.widgetId = cfg.widget;
    widget.widgetConfig = widget.widgetId.replace(/^.+?:/, '');
    const serverUrl = _resolveServerUrl(cfg, staticProps);
    widget.widget_url = serverUrl + staticProps.widget_path;
    widget.api_url = _resolveApiUrl(cfg, staticProps, serverUrl);
    widget.cssUrl = _resolveCssUrl(cfg, staticProps, widget.widget_url, env);
    widget.dataUrl = widget.api_url + staticProps.api_path + widget.widgetConfig;

    widget.ns = ' ' + staticProps.widgetClass;
    widget.domid = domid(widget.ns);

    widget.m = mithril;
    widget.µ = mithril.µ;

    env.lang = _domLang(env.wrapperElm);
    widget.txt = text(widget, cfg.lang);


    widget.sizeMonitor = sizeMonitor(widget);
    widget.mediaFormats = staticProps.mediaFormats;

    widget.wrapperClass = staticProps.wrapperClass;
    widget.widgetClass = staticProps.widgetClass;

    // expose the widget instance
    wrapperElm.belgingurWidget = widget;

    return widget;
};


const createWidgetFactory = function (staticWidgetCfg, initializerFn) {
    const widgetFactory = function (cfg, wrapperElm) {
        const widget = initWidget(widgetFactory, cfg, wrapperElm, staticWidgetCfg);
        return initializerFn(widget, cfg) || widget;
    };
    widgetFactory.widgetName = staticWidgetCfg.widgetName;
    return widgetFactory;
};


export default createWidgetFactory;
